import { Validator } from '@vista-digital/validator';
export const defaultPasswordRules = [
    {
        displayText: 'Uppercase letter',
        regExpression: '([A-Z])'
    },
    {
        displayText: 'Lowercase letter',
        regExpression: '([a-z])'
    },
    {
        displayText: 'Numeric character',
        regExpression: '([0-9])'
    },
    {
        displayText: 'At least 8 characters',
        regExpression: '.{8,}'
    }
];
export const passwordRuleValidator = Validator.object({
    displayText: Validator.string({ minLength: 1 }),
    regExpression: Validator.string({ minLength: 1 })
});
